<template>
<v-card
    class="mx-auto"
    max-width="100%"
  >
  <v-card
    class="mx-auto"
    max-width="100%"
  >

        <v-row >
           <v-col cols="12" md="1">
          <v-img
            src="http://restrito.esaudeluanda.com:7000/config/nulo-foto.jpg"
            alt="Snow"
            width="90"
          ></v-img>
        </v-col>
        <v-col cols="12" md="8">
          <h1>{{this.relatorio_Dados.especificacaoRelatorio.descricao}}</h1>
          Período:{{this.relatorio_Dados.data_in}} à {{this.relatorio_Dados.data_fim}}
          <br>Gerado em: {{this.date}}
          <v-progress-circular v-if="isLoading" class="v-progress-circular" style="color:blue"
      :size="50"
      :width="10"
      indeterminate
      color="blue"
    ></v-progress-circular>
        </v-col>
         <v-col cols="12" md="2">
            <img @click="imprimirRelatorio()" style="margin-left:30px"  width="50px"  src="../../assets/pdf_exibir.png">
           <img @click="excelPrint()" style="margin-left:30px"  width="50px"  src="../../assets/download.png">
        </v-col>
      </v-row>
      <v-card>
              <template>
                <v-simple-table class="tabela" fixed-header>
                  <template v-slot:default>
                    <thead>
                      <td class="linhas">Ord.</td>
                       <td class="linhas">Cód</td>
    <td class="linhas">Cliente</td>
    <td class="linhas">Data</td>
    <td class="linhas">Horário</td>
    <td class="linhas">Situação</td>
    <td class="linhas">Total</td>
                    </thead>

                    <tbody>
<tr v-for="(item,i) in vendas" :key="i">
  <td  class="tabela">{{ i+1 }}</td>
    <td class="linhas">{{item.pkVenda}}</td>
    <td class="linhas">{{item.cliente}}</td>
    <td class="linhas">{{item.data_compra.substr(0, 10)}}</td>
    <td class="linhas">{{item.data_compra.substr(11, 12)}}</td>
    <td class="linhas">{{relatorio_Dados.situacao.descricao}}</td>
    <td class="linhas">{{item.valorAPagar}}</td>
</tr>
<tr>
    <td colspan="7" style="text-align:right">Formas de pagamentos</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">{{relatorio_Dados.formaPagamento.nome}}</td>
    <td  style="text-align:right" class="linhas">{{formatMoney(total)}}</td>
</tr>
<tr>
    <td colspan="7" style="text-align:right" class="linhas">Totais</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Ticket Médio</td>
    <td  style="text-align:right" class="linhas">{{tk_medio}}</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Qtd. de vendas</td>
     <td  style="text-align:right" class="linhas">{{quant_vendas}}</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Desconto</td>
    <td  style="text-align:right" class="linhas">{{formatMoney(desconto)}}</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Total</td>
    <td  style="text-align:right" class="linhas">{{formatMoney(total)}}</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Lucro</td>
    <td  style="text-align:right" class="linhas">0,00kz</td>
</tr>
                    </tbody>
                  </template>
                </v-simple-table>
                 <template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
         Exportar para Excel - Deseja Continuar
        </v-card-title>

        <v-card-text>
            Clique para Continuar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="background-color:red;color:white" @click="dialog=false">Cancelar</v-btn>
           <export-excel
                :data   = "vendas"
              :fields="headExcel"
              >
          <v-btn @click="dialog=false">Continuar</v-btn>
        </export-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </template>
              </template>
            </v-card>
  </v-card>
  </v-card>
</template>

<script>
import axios from '../../plugins/axios'
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
const ls = require('local-storage')
export default {
  data () {
    return {
      option: { 'format': 'A4',
        'border': { 'top': '30cm', // default is 0, units: mm, cm, in, px
          'right': '50cm',
          'bottom': '2.5cm',
          'left': '50cm'
        }
      },
      headExcel: '',
      dialog: false,
      html: ``,
      isLoading: false,
      descricaoRelatorio: '',
      date: '',
      periodo: '',
      relatorio_Dados: {
        'tipo': 0,
        'descricaoRelatorio': '',
        'especificacaoRelatorio': {
          'pkrelatorio': 0,
          'descricao': '' },
        'data_in': '',
        'data_fim': '',
        'formaPagamento': {
          'pk_forma_pagamento': 0,
          'nome': '',
          'instituicao': 0,
          'status_forma_pagamento': 0 },
        'cliente': {
          'pk_estudante': 0,
          'numero_matricula': 0,
          'saldo': 0,
          'fk_classe': 0,
          'has_multa': 0,
          'nome': '',
          'instituicao': 0,
          'data_cadastro': '',
          'status_estudante': 0,
          'ano_lectivo': 0,
          'municipio': '',
          'pai': '',
          'mae': '',
          'data_nascimento': '',
          'sexo': '',
          'curso': '',
          'numero_documento': '',
          'data_emissao': '',
          'cidade_emissao': '',
          'municipio_emissao': '',
          'rua_casa': '',
          'telefone': '',
          'email': '',
          'turma': '',
          'idmatricula_interno': '',
          'flag_isnew': 0
        },
        'produto':
      {
        'pkProduto': 0,
        'descricao': '',
        'descricaoReduzida': '',
        'codigoBarra': '',
        'armazem': 0,
        'tipoProduto': 0,
        'mercadoria': 0,
        'familia': 0,
        'precoCusto': 0.0,
        'precoComIva': 0.0,
        'precoSemIva': 0.0,
        'margem': 0.0,
        'iva': 0,
        'isencao': '',
        'descricaoPreco': '',
        'imagem': '',
        'entrada_stk': 0,
        'saida_stk': 0
      },
        'situacao': {
          'pkSituacao': 3,
          'descricao': 'Concretizada'
        },
        'vendedor': {
          'cod': 0,
          'nome': ''
        }
      },
      vendas: [
        {
          'pkVenda': 0,
          'numeroDocumento': '',
          'cliente': '',
          'nif': 0,
          'serie': 0,
          'fkTipoDocumento': 0,
          'fkFormaPagamento': 0,
          'produto': '',
          'fkProduto': 0,
          'codigoBarra': 0,
          'qtd_venda': 0,
          'precoUnitario': 0,
          'subTotal': 0,
          'valorIliquido': 0,
          'valorAPagar': 0,
          'valorPago': 0,
          'desconto': 0,
          'troco': 0,
          'iva': 0,
          'Texto': '',
          'data_compra': ''
        }
      ],
      json_fields: {
        'Complete name': 'name',
        'City': 'city',
        'Telephone': 'phone.mobile',
        'Telephone 2': {
          field: 'phone.landline',
          callback: (value) => {
            return `Landline Phone - ${value}`
          }
        }
      },
      json_data: [
        {
          'name': 'Tony Peña',
          'city': 'New York',
          'country': 'United States',
          'birthdate': '1978-03-15',
          'phone': {
            'mobile': '1-541-754-3010',
            'landline': '(541) 754-3010'
          }
        },
        {
          'name': 'Thessaloniki',
          'city': 'Athens',
          'country': 'Greece',
          'birthdate': '1987-11-23',
          'phone': {
            'mobile': '+1 855 275 5071',
            'landline': '(2741) 2621-244'
          }
        }
      ],
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      total: 0,
      desconto: 0,
      tk_medio: 0,
      quant_vendas: 0,
      formatter: 0,
      pdf: []
    }
  },
  created () {
    this.date = this.correntDate()
    this.relatorio_Dados = ls.get('relatoriosVendas')
    this.venda()
  },
  methods: {
    excelPrint () {
      this.dialog = true
    },
    imprimirRelatorio () {
      this.isLoading = true
      setTimeout(() => {
        this.$router.push('/imprimir_pdf')
      }, 30000)
    },

    async venda () {
      let datas = {
        'data_ini': this.relatorio_Dados.data_in,
        'data_fim': this.relatorio_Dados.data_fim,
        'nif': this.relatorio_Dados.cliente.numero_matricula,
        'pkProduto': this.relatorio_Dados.produto.pkProduto,
        'pk_forma_pagamento': this.relatorio_Dados.formaPagamento.pk_forma_pagamento
      }
      try {
        this.vendas = await axios
          .post('/vendas', datas)
          .then(res => res.data)
        this.isLoading2 = false
        this.quant_vendas = this.vendas.length
        this.totalVendas()
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    totalVendas () {
      this.total = 0
      this.desconto = 0
      this.vendas.forEach(element => {
        this.total += element.valorAPagar
        this.desconto += element.desconto
      })
      // Arredondar por excesso
      if (this.quant_vendas > 0) { this.tk_medio = ((this.total) / this.quant_vendas).toFixed(0) }
      this.comporHTML()
    },

    async gerarPdf () {
      try {
        await axios({
          method: 'post',
          url: 'http://relatorios.softlineangola.com/writefile', //  http://localhost:8082
          data: {
            html: this.html,
            file_name: ls.get('nomeUsuario'),
            option: this.option
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF

        this.progresso = false
        this.frame()
      } catch (error) {
        this.progresso = false
      }
    },
    frame () {
      this.url = 'http://relatorios.softlineangola.com/readfile/' + ls.get('nomeUsuario') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + this.url + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
      this.progresso = false
    },
    formatMoney (value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
    comporHTML () {
      let dadosVenda = ``
      let i = 0
      this.headExcel = { 'Cod': 'numeroDocumento', 'Cliente': 'cliente', 'Data': 'data', 'Hora': 'hora', 'Total pago': 'valorAPagar' }
      this.vendas.forEach(element => {
        i++
        dadosVenda += `<tr>
    <td class="linhas">` + i + `</td>
    <td class="linhas">` + element.numeroDocumento + `</td>
    <td class="linhas">` + element.cliente + `</td>
    <td class="linhas">` + element.data + `</td>
    <td class="linhas">` + element.hora + `</td>
    <td class="linhas">` + this.relatorio_Dados.situacao.descricao + `</td>
    <td class="linhas">` + element.valorAPagar + `</td>
</tr>`
      })
      this.html = `

<style>
.linhas {
  border: 1px solid black;
  border-collapse: collapse;
}

</style>

<html>
    <head>
        <title>Recibos</title>
    </head>
<body>
    <table style="border:0px solid black;margin-left:0px;margin-right:auto;">
    <tr>
        <td>
            <div class="column">
   <span style="padding-top:1px!important">  <img src="http://restrito.esaudeluanda.com:7000/config/IMS/icon/logo.png" alt="Snow" style="width:100%; max-width:150px;" /></span>
  </div>
        </td>
         <td> 
       <h1>` + this.relatorio_Dados.especificacaoRelatorio.descricao + `</h1>
<br><span>Período: ` + this.relatorio_Dados.data_in + `à` + this.relatorio_Dados.data_fim + `</span>
<br><span>Gerado em: ` + this.date + ` </span>
        </td>
         
    </tr>
    
       </table>


<br>
<table width=100% class="linhas">
<tr class="linhas">
    <td class="linhas">Ord.</td>
    <td class="linhas">Cód</td>
    <td class="linhas">Cliente</td>
    <td class="linhas">Data</td>
    <td class="linhas">Horário</td>
    <td class="linhas">Situação</td>
    <td class="linhas">Total</td>
</tr>
` + dadosVenda + `
<tr>
    <td colspan="7" style="text-align:right">Forma de pagamentos</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Dinheiro à vista</td>
    <td  style="text-align:right" class="linhas">` + this.formatMoney(this.total) + `</td>
</tr>
<tr>
    <td colspan="7" style="text-align:right" class="linhas">Totais</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Ticket Médio</td>
    <td  style="text-align:right" class="linhas">` + this.tk_medio + `</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Qtd. de vendas</td>
     <td  style="text-align:right" class="linhas">` + this.quant_vendas + `</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Desconto</td>
    <td  style="text-align:right" class="linhas">` + this.formatMoney(this.desconto) + `</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Total</td>
    <td  style="text-align:right" class="linhas">` + this.formatMoney(this.total) + `</td>
</tr>
<tr>
    <td colspan="6" style="text-align:right" class="linhas">Lucro</td>
    <td  style="text-align:right" class="linhas">0,00kz</td>
</tr>
</table>
   
</body>
</html>`
      this.gerarPdf()
    },
    correntDate () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth() + 1)] + ' de ' + data.getFullYear().toString()
    }
  }
}
</script>
<style scoped>
.linhas {
  border: 1px solid black;
  border-collapse: collapse;
}
</style>
